/* eslint-disable jira/filename-case */
export const NAVIGATION_UI_STORAGE_KEY = 'navigation_next_ui_state' as const;
export const LOGGER_LOCATION = 'navigation-next.providers.ui-state-cache-provider' as const;
